import React, { useState } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import { KeyboardArrowRight } from '@material-ui/icons';
import { cloneDeep } from 'lodash';
import { Button } from '@material-ui/core';
import { getStaticText } from '../../utils/constants';
import CloseIcon from '../../assets/Close.svg';
import '../FilterBar/index.scss';
import FilterContent from './FilterContent';
import { getTabName, getMaxRange } from '../../containers/Analytics/assets/functions';

function FilterBar({
    closeFilters,
    filters,
    setFilters,
    defaultSettings,
    filtersApplied,
    filtersMapping,
    defaultFilters,
    isFiltersApplied,
    hideFilterIds,
    range,
    setRange,
    dataAtGlance,
}) {
    const { lang } = defaultSettings;
    const staticText = getStaticText(lang);
    const { SITE_TEXT } = staticText;
    const [activeProject, updateCurrentFilter] = useState(null);
    const [stateFilters, updateFilters] = useState(filters);
    const [demoSelected, setDemoActive] = useState(false);
    const { FILTER_FOR, RESET_FILTERS, APPLY_FILTERS, TOTAL_RESPONDENTS, N_SIZE } = SITE_TEXT || {};
    const itemInFilter = filters.map(({ filter_name }) => filter_name);
    const [isOpen, setIsOpen] = useState(true);
    const { survey_completion = '', total_survey = '' } = dataAtGlance || {};

    const selectOptions = filterObj => {
        const filterItem = cloneDeep(filterObj);
        const noneSelected = !filterItem
            // .filter(({ filter_id }) => filter_id !== 'year')
            .filter(({ isSelected = false }) => isSelected).length;
        if (noneSelected) {
            return filterItem;
        }
        filterItem
            // .filter(({ filter_id }) => filter_id !== 'year')
            .forEach(_item => {
                const { filter_items = [], isSelected = false } = _item;
                if (isSelected) {
                    const selectedArr = [];
                    filter_items.forEach(({ filter_item_id, isSelected: selectedChild = false }) => {
                        if (selectedChild) {
                            selectedArr.push(filter_item_id);
                        }
                    });
                }
            });
        return filterItem;
    };

    const updateFilterState = (index, value, updateRedux, activeFilter = true) => {
        const list = [...stateFilters.slice(0, index), value, ...stateFilters.slice(index + 1)];
        const newList = selectOptions(list);
        updateFilters(newList);
        if (updateRedux) {
            setFilters(newList, activeFilter);
            closeFilters(false);
        }
        return newList;
    };

    const applyFiltersToRedux = () => {
        setFilters(stateFilters, true);
        closeFilters(false);
    };

    const resetFilters = () => {
        const maxRangeTotalComplete = getMaxRange(defaultFilters, 'totalcomplete') || 165416;
        const maxRangeTotalInvited = getMaxRange(defaultFilters, 'totalinvited') || 165416;
        setRange({
            totalcomplete: [0, maxRangeTotalComplete],
            totalinvited: [0, maxRangeTotalInvited],
        });
        updateFilters(defaultFilters);
        setDemoActive(false);
        // Always call setFilters to trigger API call on reset
        setFilters(defaultFilters, false);
    };

    const checkAppliedFilter = filterObj => {
        const { filter_items = [] } = filterObj;
        for (let i = 0; i < filter_items.length; i += 1) {
            const { isSelected = false } = filter_items[i];
            if (isSelected) {
                return true;
            }
        }
        return false;
    };

    const handleClose = () => {
        setTimeout(() => {
            closeFilters(false);
        }, 200);
        setIsOpen(false);
    };
    return (
        <div className="filterDialogAnalytics filterDialog" data-testid="filterDialog">
            <div className="backdropRoot" onClick={handleClose} />
            <div className={`rightSideFilters ${isOpen ? 'slideIn' : 'slideOut'}`}>
                <div className="filterContent">
                    <div className="topContent clearfix">
                        <h2>{FILTER_FOR}</h2>
                        <div className="closeContent">
                            <img data-testid="closeFilters" src={CloseIcon} alt="" onClick={handleClose} />
                        </div>
                    </div>
                    <div className="sizeInfo thresholdInfo">
                        {TOTAL_RESPONDENTS} {survey_completion.toLocaleString('en-US')}
                        <span>
                            {N_SIZE}: {total_survey}
                        </span>
                    </div>
                    <div className="upperContent">
                        {activeProject === null && (
                            <ul className="selectList">
                                {filters.map(({ filter_name, filter_id }, index) => {
                                    const isFilterApplied = checkAppliedFilter(filters[index]);
                                    const isHidden = hideFilterIds.includes(filter_id);
                                    const filterName = getTabName(filter_name);
                                    return !isHidden ? (
                                        <li
                                            data-testid={filterName}
                                            key={index}
                                            onClick={() => updateCurrentFilter(index)}
                                            className={c('filtered', {
                                                filtersApplied: isFilterApplied,
                                            })}
                                        >
                                            {filterName}
                                            <KeyboardArrowRight />
                                        </li>
                                    ) : null;
                                })}
                            </ul>
                        )}
                    </div>
                </div>
                {activeProject !== null || !itemInFilter.length ? (
                    <FilterContent
                        setDemoActive={setDemoActive}
                        activeApplyButton={demoSelected}
                        updateFilterState={updateFilterState}
                        applyFiltersToRedux={applyFiltersToRedux}
                        updateCurrentFilter={updateCurrentFilter}
                        closeFilters={closeFilters}
                        showHeader={itemInFilter[activeProject]}
                        resetFilters={resetFilters}
                        filters={stateFilters}
                        activeProject={activeProject}
                        defaultSettings={defaultSettings}
                        filtersApplied={filtersApplied}
                        defaultFilters={defaultFilters}
                        filtersMapping={filtersMapping}
                        updateFilters={updateFilters}
                        isFiltersApplied={isFiltersApplied}
                        setIsOpen={setIsOpen}
                        setRange={setRange}
                        range={range}
                    />
                ) : null}
                {!isNaN(activeProject) && (
                    <div className="buttonContent clearfix">
                        <Button
                            classes={{ root: c({ active: demoSelected || isFiltersApplied }) }}
                            onClick={resetFilters}
                        >
                            {RESET_FILTERS}
                        </Button>
                        <Button classes={{ root: c({ active: demoSelected }) }} onClick={() => applyFiltersToRedux()}>
                            {APPLY_FILTERS}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

FilterBar.propTypes = {
    filters: PropTypes.array.isRequired,
    closeFilters: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    filtersApplied: PropTypes.bool.isRequired,
    filtersMapping: PropTypes.array.isRequired,
    defaultFilters: PropTypes.array.isRequired,
    isFiltersApplied: PropTypes.bool.isRequired,
    hideFilterIds: PropTypes.array.isRequired,
    range: PropTypes.array.isRequired,
    setRange: PropTypes.func.isRequired,
    dataAtGlance: PropTypes.object.isRequired,
};

export default FilterBar;
